import React, { Component } from 'react';
import { ThemeContext } from 'app-themes';
import UserProfileBox from './UserProfileBox';
import { NotificationByEmailDisplay, alternativeContactsWrapper } from 'components';
import { AlternativeContactWithNotifications } from 'AppClient/api/UserProfile/UserProfileTypes';
import styles from './styles.module.scss';

interface Props {
	alternativeContactList: AlternativeContactWithNotifications[];
	getLinkWithTooltip: (linkPrefix: string, payload: string, tooltipText: string) => JSX.Element;
	getPhoneWithCode: (phoneCodeCountryId: number, phoneNumber: string) => string;
}

export class AlternativeContactsSection extends Component<Props> {
	static contextType = ThemeContext;

	render() {
		const { alternativeContactList, getLinkWithTooltip, getPhoneWithCode } = this.props;

		return (
			<div className={styles.alternativeContactWrap}>
				<h3 className={styles.billingDetailsHeader}>Alternative contacts</h3>
				<div className={styles.userRow}>
					{alternativeContactList.map((contact: AlternativeContactWithNotifications) => (
						<UserProfileBox key={contact.id}>
							<ul className={styles.userList}>
								<li>{contact.fullName}</li>
								{contact.phoneCodeCountryId && contact.phoneNumber && (
									<li>
										{getLinkWithTooltip(
											'tel:',
											getPhoneWithCode(
												contact.phoneCodeCountryId,
												contact.phoneNumber
											),
											'Phone'
										)}
									</li>
								)}
								{contact.emailAddress && (
									<li>
										{getLinkWithTooltip(
											'mailto:',
											contact.emailAddress,
											'E-mail'
										)}
									</li>
								)}
							</ul>
							<div className={styles.notificationListWrap}>
								<h4 className={styles.userListLabel}>Notifications by email</h4>
								<NotificationByEmailDisplay
									bookingConfirmation={contact.bookingConfirmation}
									invoiceConfirmation={contact.invoiceConfirmation}
									calendarBookingEvent={contact.calendarBookingEvent}
								/>
							</div>
						</UserProfileBox>
					))}
				</div>
			</div>
		);
	}
}

export default alternativeContactsWrapper(AlternativeContactsSection);
